import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-terms',
    templateUrl: './terms.component.html',
    styleUrls: ['./terms.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TermsComponent {

}
